import { ButtonLink } from '../components/Button';
import { BallMark } from '../components/BallMark';

export function NotFound() {
  return (
    <main className="page" style={{ justifyContent: 'center', alignItems: 'center', gap: '1rem' }}>
      <BallMark size={88} />
      <h1 style={{ fontSize: 'var(--text-2xl)' }}>Nothing here</h1>
      <p style={{ color: 'var(--ink-soft)', textAlign: 'center' }}>
        That page rolled away somewhere.
      </p>
      <ButtonLink to="/">Back home</ButtonLink>
    </main>
  );
}
